/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';
import Config from './config/config';

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import VueSession from 'vue-session';
import VueTailwind from 'vue-tailwind';
import { TModal } from 'vue-tailwind/dist/components';

const tailWindSettings = {
  't-modal': {
    component: TModal,
    props: {
      fixedClasses: {
        overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed',
        wrapper: 'relative mx-auto',
        modal: 'overflow-visible relative bg-white shadow width-class mx-auto',
        close: 'flex items-center justify-center',
        header: 'h4',
      },
      hideCloseButton: true,
    },
  },
};
Vue.use(VueSession, { persist: true });
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: 'rgb(18, 83, 158)',
      success: '#4ECF4E',
      warning: 'rgb(255, 159, 67)',
      danger: 'rgb(234, 84, 85)',
      dark: 'rgb(0, 0, 0)',
    },
  },
});
Vue.use(VueTailwind, tailWindSettings);

// axios
import axios from 'axios';

Vue.prototype.$http = axios;

// Globally Registered Components
import './globalComponents.js';

// Globally Registered Directives
import './globalDirectives.js';

// Styles: SCSS
import './assets/scss/main.scss';

// Tailwind
import './assets/css/main.css';

import './assets/css/ag-grid-overrides.css';

// Vue Router
import router from './router';

// Vuex Store
import store from './store/store';

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';

Vue.use(VueHammer);

// i18n
import { i18n } from './i18n';

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// Feather font icon
require('./assets/css/iconfont.css');

Config.loadConfig().then(() => {
  axios.defaults.baseURL = Config.getValue('baseUrl');
  Vue.config.productionTip = false;
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
});
